import React from "react";
import Header from "../../components/Header";
import Cover from "./Cover";
import About from "./About";
import Events from "./Events";
import Missions from "./Missions";
import Experience from "./Experience";
import ContactUs from "./ContactUs";
import Footer from "../../components/Footer";

const HomePage = () => {
  return (
    <div>
      <Header />
      <Cover />
      <About />
      <Events />
      <Missions />
      <Experience />
      <ContactUs />
      <Footer />
    </div>
  );
};

export default HomePage;
